<modal class="modal-size-lg">
  <modal-content>
    <xea-grid-header
      [addBtn]="addBtn"
      [refreshBtn]="refreshBtn"
      (onSearch)="onSearchChange($event)"
      [showFilters]="showFilters"
      [filters]="filters || defaultFilters"
      (onApplyFilters)="onApplyFilters($event)"
    ></xea-grid-header>

    <div class="title-bar">
      @if (mainTitle || subTitle) {
        <h3 class="title-text">
          {{ buildDisplayTitle() }}
        </h3>
      }
      <span class="showing-items">{{
        showingItemsText | translate: showingItemsParams
      }}</span>
    </div>

    <div class="grid-list">
      <dm-grid
        [columnDefs]="columnDefs"
        [dmGridClass]="'grid-class'"
        [gridOptions]="gridOptions"
        [rowData]="gridData"
        [adjustHeightForSingleTouchScroll]="true"
        [fullSizeTable]="true"
        [noRowsTemplate]="noRowsTemplate | translate"
      >
      </dm-grid>
    </div>

    @if (tips) {
      <div class="grid-info">
        <span class="info-text">{{ tips }}</span>
      </div>
    }

    @if (footerButtons && footerButtons.length > 0) {
      <div class="footer-buttons">
        <xea-buttons [buttons]="footerButtons"></xea-buttons>
      </div>
    }
  </modal-content>
</modal>

<xea-global-loading-overlay
  [showLoader]="showLoader"
></xea-global-loading-overlay>
